var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configuracion-view"},[_c('ComingSoon',{attrs:{"label":_vm.currentLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }